export const getCloneName = (name, items) => {
  const cloneNamePrefix = `${name} - clone`;
  const clones = items.filter(
    ({title}) =>
      title.startsWith(cloneNamePrefix) &&
      title.replace(cloneNamePrefix, '').split('-').length === 1
  );
  if (!clones.length) {
    return `${cloneNamePrefix} 1`;
  }
  clones.sort((a, b) => {
    return a.title > b.title ? -1 : 1;
  });
  const lastCloneIndex = Number(clones[0].title.split(' ').slice(-1)[0]);
  return `${cloneNamePrefix} ${lastCloneIndex + 1}`;
};
